import { Module } from 'vuex';

export interface User {
  pictureLocation: string | null;
  userName: string | null;
  token: string | null;
  customerId: string | null;
  plan: string | null;
  billDate: string | null;
  isAuthenticated: boolean;
  hasSeenTutorial: boolean;
  hasRouter: boolean;
}

const defaultState: User = {
  pictureLocation: null,
  userName: null,
  token: null,
  customerId: null,
  plan: null,
  billDate: null,
  isAuthenticated: false,
  hasSeenTutorial: false,
  hasRouter: false
};

const userStore: Module<User, {}> = {
  state: defaultState,
  mutations: {
    sawTutorial(state) {
      state.hasSeenTutorial = true;
    },
    hasRouter(state) {
      state.hasRouter = true;
    },
    logIn(state, user: { userName: string; token: string; customerId: string; plan: string; billDate: string }) {
      state.userName = user.userName;
      state.token = user.token;
      state.isAuthenticated = true;
      state.customerId = user.customerId;
      state.plan = user.plan;
      state.billDate = user.billDate;
    },
    logOut(state) {
      state.userName = null;
      state.token = null;
      state.isAuthenticated = false;
    },
    updateUserPicture(state, pictureLocation: string) {
      state.pictureLocation = pictureLocation;
    }
  },
  actions: {
    sawTutorial({ commit }) {
      commit('sawTutorial');
    },
    hasRouter({ commit }) {
      commit('hasRouter');
    },
    logIn({ commit }, user: { userName: string; token: string; customerId: string; plan: string; billDate: string }) {
      // setTimeout(() => {
      commit('logIn', user);
      // }, 50);
    },
    logOut({ commit },) {
      commit('logOut');
    },
    updateUserPicture({ commit }, pictureLocation: string) {
      setTimeout(() => {
        commit('updateUserPicture', pictureLocation);
      }, 50);
    }
  }
};

export default userStore;
